export const contactObj = {
  primary: true,
}